import React, { FC, useEffect, useMemo, useState } from 'react';
import { TeamID } from '../../../scripts/models/common';
import { Modification, TeamModel } from '../../../scripts/models/models';
import { sum } from '../../../scripts/utility';
import TeamIcon from '../../common/teamIcon/TeamIcon';

interface IProps {
    team: TeamModel,
    value: number,
    scale: number,
    position?: number
}

function randomColor(set: string[]) {
    const idx = Math.floor(Math.random() * set.length);
    return set[idx];
}

function complementaryColor(color: string) {
    const [r, g, b] = [color.substr(1, 2), color.substr(3, 2), color.substr(5, 2)].map(a => parseInt(a, 16) / 256)
    if ([r, g, b].reduce(sum) > 2.0) {
        return randomColor(["FireBrick", "MediumVioletRed", "DeepPink", "OrangeRed", "BlueViolet", "SlateBlue", "SeaGreen", "Teal", "MediumBlue", "Maroon"])
    }

    return randomColor(["LightCoral", "LightPink", "PaleGoldenrod", "Plum", "PaleGreen", "DarkSeaGreen", "Turquoise"]);
}

type oldModification = {
    teamId: TeamID,
    modification: Modification
}
function isOldModification(obj: oldModification | Modification): obj is oldModification {
    return (obj as any).modification !== undefined
}

const TeamRow: FC<IProps> = (props) => {
    const { team, value, scale, position } = props;

    const [atZero, setAtZero] = useState(true);

    useEffect(() => {
        setTimeout(() => { setAtZero(false) }, 100);
    }, []);

    const partyTime = team.modifications.map(obj => (isOldModification(obj) ? obj.modification : obj).name).filter(name => name === "Party Time").length > 0;

    const partyColor = useMemo<string>(() => complementaryColor(team.primaryColor), [team])

    return (
        <div className="SingleTeamRow">
            <TeamIcon emoji={team.emoji} color={team.primaryColor} shape="Rank Logo" rank={position}
                partyTime={partyTime} hatColor={partyColor} />
            <div className="TeamRow-Name bodyText">{team.name}</div>
            <div className="TeamRow-Bar" style={{
                width: atZero ? 0 : (value * 5 * scale) + "px",
                backgroundColor: team.primaryColor,
            }} />
            <div className="TeamRow-Value">{value}</div>
        </div>)
}

export default TeamRow;